import metaTags from '@/finsight/ui/common/metaTagsConstants';
import { ProfileTypes } from '@/finsight/application/actions/profile/constants';
import { IMetaTags, IgetMetaTagsByFilters } from './types';

type TgetPossibleSectorMetaTags = Pick<IgetMetaTagsByFilters, 'profileType' | 'sector'>;

export const getPossibleSectorMetaTags = ({ profileType, sector }: TgetPossibleSectorMetaTags): IMetaTags => {
  if (profileType === ProfileTypes.SECTOR) {
    const sectorName = sector.metaTitleName;

    if (sector.subsectorId) {
      return metaTags.getSectorSubsectorProfile(sectorName);
    }

    return metaTags.getSectorProfile(sectorName);
  }

  return null;
};
